import { render, staticRenderFns } from "./programs.vue?vue&type=template&id=6fb2c544&scoped=true&"
import script from "./programs.vue?vue&type=script&lang=js&"
export * from "./programs.vue?vue&type=script&lang=js&"
import style0 from "./programs.vue?vue&type=style&index=0&id=6fb2c544&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb2c544",
  null
  
)

export default component.exports